import PageNotFound from './pagenotfound';

export default PageNotFound;